module.exports = __webpack_public_path__ + "static/media/femalePatient.6f0f3be7.png";